import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2k3t71ozhd: FaireBrandEntity = {
  token: "b_2k3t71ozhd",
  type: "brand",
  name: "Arrae",
  avatarUrl:
    "https://cdn.faire.com/fastly/b7c95a858c2b4243f2d8f4918a1cb1515592274bcd4f4b99760075a5bf6bc5e4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ab668b8e44922d3b9a7e6ad28d5c3d6198b7ba35b0cd100f28f9698d601a0a8b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b7c95a858c2b4243f2d8f4918a1cb1515592274bcd4f4b99760075a5bf6bc5e4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ab668b8e44922d3b9a7e6ad28d5c3d6198b7ba35b0cd100f28f9698d601a0a8b.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 260,
  rating: 4.9,
  reviewCount: 10,
  isInsider: false,
  description:
    '"I’d struggled with health issues for years and turned to natural remedies as a last resort. After troubleshooting my own health problems through the use of herbs, minerals and vitamins, I realized that natural products had the power to solve women’s toughest day-to-day health issues. The trouble was that I couldn’t find natural, organic, high-quality supplements which solved targeted problems while being beautiful. I wanted to bridge this gap and bring women an efficacious product which really spoke to them."\n\n- Siff Haider\n\n"Coming from a tech background, health and wellness isn’t something that’s talked about enough. Because of this lack of education, I’d dealt with high levels of stress and fatigue and didn’t even have the vernacular to realize that I had these issues. Having been introduced to natural products, I became passionate about building a brand that would educate others and make a lasting impact on how they felt."\n\n- Nish Samantray',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:06.625Z",
    importedBy: "entity-db-cli",
  },
};
